(() => {
  const SELECTOR = '.regular-gift-note';

  function addGiftNoteToCart(variantId, noteText) {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: parseInt(variantId, 10),
          quantity: 1,
          properties: { message_1: noteText }
        }]
      })
    }).then((response) => {
      if (!response.ok) throw new Error('Cart add failed');
      return response.json();
    });
  }

  class RegularBuyButtonGiftNote {
    constructor(container) {
      this.container = container;
const productFormEl = container.closest('product-form');
    this.form = productFormEl?.querySelector('form[data-type="add-to-cart-form"]')
      || productFormEl?.querySelector('form[action*="cart/add"]')
      || productFormEl?.querySelector('form');
    this.submitButton = this.form?.querySelector('[name="add"]');
    this.variantInput = this.form?.querySelector('input[name="id"], input.product-variant-id');

      if (!this.form || !this.submitButton) return;

      this.giftNoteVariantId = container.dataset.giftNoteVariantId;
      this.giftNotePrice = parseInt(container.dataset.giftNotePrice, 10) || 0;
      this.currencyCode = container.dataset.currencyCode || 'NZD';

      this.toggleRow = container.querySelector('.regular-gift-note-toggle-row');
      this.toggleButton = container.querySelector('.regular-gift-note-toggle');
      this.noteField = container.querySelector('.regular-gift-note-field');
      this.textarea = container.querySelector('.regular-gift-note-textarea');
      this.clearButton = container.querySelector('.regular-gift-note-clear');
      this.priceSpan = this.submitButton.querySelector('.price-on-atc-button');

      this.isActive = false;
      this.isProcessed = false;
      this.wasDisabledBeforeLoading = this.submitButton.disabled;

      this.variantPriceMap = new Map();
      this.buildVariantPriceMap();
      this.bindEvents();
      this.updateButtonPrice();
    }

    buildVariantPriceMap() {
      const variantDataEl = this.container.querySelector('.regular-gift-note-variant-data');
      if (!variantDataEl) return;

      try {
        const variants = JSON.parse(variantDataEl.textContent || '[]');
        variants.forEach((variant) => {
          this.variantPriceMap.set(String(variant.id), parseInt(variant.price, 10) || 0);
        });
      } catch (error) {
        console.error('Failed to parse variant pricing for gift note UI:', error);
      }
    }

    bindEvents() {
      if (this.toggleButton && this.noteField && this.toggleRow && this.textarea) {
        this.toggleButton.addEventListener('click', () => {
          this.isActive = true;
          this.noteField.hidden = false;
          this.toggleRow.hidden = true;
          this.textarea.focus();
          this.updateButtonPrice();
          if (window.clarity) window.clarity('event', 'gift_note_opened_pdp');
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: 'gift_note_added',
            ecommerce: {
              currency: this.currencyCode,
              value: this.giftNotePrice / 100,
              items: [{
                item_id: this.giftNoteVariantId,
                item_name: 'Gift Note',
                price: this.giftNotePrice / 100,
                quantity: 1
              }]
            }
          });
        });
      }

      if (this.clearButton && this.noteField && this.toggleRow && this.textarea) {
        this.clearButton.addEventListener('click', () => {
          this.isActive = false;
          this.textarea.value = '';
          this.noteField.hidden = true;
          this.toggleRow.hidden = false;
          this.updateButtonPrice();
        });
      }

      // Dawn's product-form uses a disabled input, so change events don't fire.
      // Listen for Dawn's variant:change event instead.
      document.addEventListener('variant:change', (event) => {
        // Only update if the event is for our product form's section
        if (!this.container.isConnected) return;
        const newVariantId = event.detail?.variant?.id;
        if (newVariantId && this.variantInput) {
          this.variantInput.value = String(newVariantId);
        }
        this.updateButtonPrice();
      });

      this.form.addEventListener('submit', (event) => this.handleFormSubmit(event), true);
    }

    handleFormSubmit(event) {
      if (this.isProcessed) {
        this.isProcessed = false;
        return;
      }

      const noteText = this.textarea ? this.textarea.value.trim() : '';
      if (!noteText || !this.giftNoteVariantId) return;

      if (window.clarity) {
        window.clarity('set', 'gift_note_text', noteText);
        window.clarity('event', 'gift_note_submitted_pdp');
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      this.setLoadingState(true);
      addGiftNoteToCart(this.giftNoteVariantId, noteText)
        .catch((error) => {
          console.error('Failed to add gift note product to cart:', error);
        })
        .finally(() => {
          this.setLoadingState(false);
          this.isProcessed = true;

          if (typeof this.form.requestSubmit === 'function') {
            this.form.requestSubmit(this.submitButton);
          } else {
            this.submitButton.click();
          }
        });
    }

    setLoadingState(isLoading) {
      const spinner = this.submitButton.querySelector('.loading-overlay__spinner');

      if (isLoading) {
        this.wasDisabledBeforeLoading = this.submitButton.disabled;
        this.submitButton.disabled = true;
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        if (spinner) spinner.classList.remove('hidden');
        return;
      }

      this.submitButton.disabled = this.wasDisabledBeforeLoading;
      if (!this.wasDisabledBeforeLoading) {
        this.submitButton.removeAttribute('aria-disabled');
      }
      this.submitButton.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
    }

    getCurrentVariantPrice() {
      const currentVariantId = this.variantInput?.value;
      if (!currentVariantId) return null;

      if (this.variantPriceMap.has(String(currentVariantId))) {
        return this.variantPriceMap.get(String(currentVariantId));
      }

      return null;
    }

    formatPrice(priceInCents) {
      const locale = document.documentElement.lang || 'en-NZ';
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: this.currencyCode,
        currencyDisplay: 'narrowSymbol'
      }).format(priceInCents / 100);
    }

    updateButtonPrice() {
      if (!this.priceSpan) return;

      const baseVariantPrice = this.getCurrentVariantPrice();
      if (baseVariantPrice === null) return;

      const totalPrice = baseVariantPrice + (this.isActive ? this.giftNotePrice : 0);
      this.priceSpan.textContent = ` - ${this.formatPrice(totalPrice)} `;
    }
  }

  function initRegularGiftNotes(root = document) {
    root.querySelectorAll(SELECTOR).forEach((container) => {
      if (container.dataset.giftNoteInit === 'true') return;
      container.dataset.giftNoteInit = 'true';
      new RegularBuyButtonGiftNote(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initRegularGiftNotes());
  } else {
    initRegularGiftNotes();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initRegularGiftNotes(event.target);
  });
})();
